import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router'; // ✅ Importa ActivatedRoute
import { HttpClient } from '@angular/common/http'; // ✅ Importa HttpClient
import { Router } from '@angular/router'; // ✅ Importa Router
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirmacion',
  templateUrl: './confirmacion.component.html',
  styleUrls: ['./confirmacion.component.scss'], // Corrección del nombre del archivo (styleUrls)
  standalone: false
})
export class ConfirmacionComponent implements OnInit {
  mensaje: string = 'Procesando solicitud...';
  estado: string;
  nombreInstitucion: any;
  valor: any;
  numfactura: any;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit(): void {
    console.log('entro en el init');
    this.procesarFactura(); // Llama a la función cuando el componente se inicializa
  }

  procesarFactura(): void {
    const idFactura = this.route.snapshot.queryParamMap.get('id_factura');
    this.estado = this.router.url.includes('APROBADO') ? 'APROBADO MÉTODO DE PAGO' : 'RECHAZADO MÉTODO DE PAGO';
    this.nombreInstitucion = this.route.snapshot.queryParamMap.get('nombreInstitucion');
    this.valor = this.route.snapshot.queryParamMap.get('valor');
    this.numfactura = this.route.snapshot.queryParamMap.get('numfactura');

    console.log(this.estado);
    console.log(this.route.snapshot.queryParamMap);
    if (!idFactura) {
      this.mensaje = 'Error: ID de factura no encontrado';
      console.log(this.mensaje);
      return;
    }
    this.http
      .post('http://192.168.0.32:4200/api/cheqex/actualizarEstadoFactura', {
        id_factura: idFactura,
        estadoFactura: this.estado,
        metodoPago: 'TRUEQUE'
      })
      .subscribe({
        next: (response) => {
          this.mensaje = `Factura ${this.estado}`; // Cierra la pestaña después de 1 segundo
        },
        error: (error) => {
          console.error('Error:', error);
          this.mensaje = 'Error al actualizar la factura.';
        }
      });
  }
}
